import type { ComponentProps } from 'react';

import styles from './animated-checkbox.module.css';

/** A persistent stroke keeps the layout fixed while the check is drawn. */
export function AnimatedCheck({ checked, size = 20 }: { checked: boolean; size?: number }) {
  return (
    <svg
      className={styles.mark}
      data-checked={checked}
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden="true"
    >
      <path d="M4.5 10 8 13.5 15.5 6" pathLength="1" />
    </svg>
  );
}

/** Visual indicator for an existing button/card that owns the checkbox semantics. */
export function CheckboxIndicator({
  checked,
  disabled = false,
  size = 20,
}: {
  checked: boolean;
  disabled?: boolean;
  size?: number;
}) {
  return (
    <span
      className={styles.box}
      data-checked={checked}
      data-disabled={disabled}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <AnimatedCheck checked={checked} size={size} />
    </span>
  );
}

export function AnimatedCheckbox({ className, ...props }: Omit<ComponentProps<'input'>, 'type'>) {
  return (
    <span className={[styles.control, className].filter(Boolean).join(' ')}>
      <input {...props} type="checkbox" className={styles.input} />
      <span className={styles.box} aria-hidden="true">
        <AnimatedCheck checked={false} />
      </span>
    </span>
  );
}
